import React, { useMemo } from 'react';
import Modal from '../ui/Modal';
import GlassButton from '../ui/Button';
import { getPriorityPillClass, getPriorityColor, getStatusColor } from '../../utils/helpers';
import useData from '../../hooks/useData';

const TaskRow = ({ task, onTaskClick, onClose }) => {
    const { projects } = useData();
    const project = useMemo(() => projects.find(p => p.id === task.projectId), [task.projectId, projects]);
    const priorityColor = getPriorityColor(task.priority);
    const statusColor = getStatusColor(task.status);

    return (
        <button
            onClick={() => { onTaskClick(task); onClose(); }}
            className="relative w-full text-left p-3 pl-5 bg-white/5 rounded-xl hover:bg-white/10 transition-colors"
        >
            <div className="absolute left-0 top-0 h-full w-1.5 rounded-l-xl overflow-hidden">
                <div style={{ backgroundColor: priorityColor }} className="h-1/2 w-full"></div>
                <div style={{ backgroundColor: statusColor }} className="h-1/2 w-full"></div>
            </div>
            <div className="flex justify-between items-center">
                <div>
                    <p className="font-bold text-white uppercase">{task.title}</p>
                    <p className="text-sm text-gray-400">{project?.name || task.client}</p>
                </div>
                <div className="flex items-center gap-4 text-xs">
                    <span className={`px-2 py-1 rounded-full ${getPriorityPillClass(task.priority)}`}>{task.priority}</span>
                    <span className="text-gray-300 w-20 text-right">{task.deadline}</span>
                </div>
            </div>
        </button>
    );
};

const DrillDownModal = ({ data, onClose, onTaskClick }) => {
    if (!data) return null;

    const { title, tasks } = data;

    // --- INÍCIO DA ALTERAÇÃO: Adicionando lógica para ordenar as tarefas por data ---
    const sortedTasks = useMemo(() => {
        if (!tasks) return [];
        // Cria uma cópia para não modificar o array original e ordena
        return [...tasks].sort((a, b) => {
            if (!a.deadline) return 1;
            if (!b.deadline) return -1;
            // Ordena da data mais recente para a mais antiga
            return new Date(b.deadline) - new Date(a.deadline);
        });
    }, [tasks]);
    // --- FIM DA ALTERAÇÃO ---

    return (
        <Modal
            isOpen={!!data}
            onClose={onClose}
            title={title}
            maxWidth="max-w-2xl"
            footer={<GlassButton onClick={onClose}>Fechar</GlassButton>}
        >
            <div className="max-h-[60vh] overflow-y-auto space-y-2 pr-2">
                {sortedTasks.length > 0 ? (
                    sortedTasks.map(task => (
                        <TaskRow 
                            key={task.id}
                            task={task}
                            onTaskClick={onTaskClick}
                            onClose={onClose}
                        />
                    ))
                ) : (
                    <p className="text-center text-gray-400 py-8">Nenhuma tarefa para exibir.</p>
                )}
            </div>
        </Modal>
    );
};

export default DrillDownModal;